import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { H3mlStore } from '../h3ml/state/h3ml-store';

@Component({
  selector: 'h3-output-warnings',
  templateUrl: './output-warnings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OutputWarningsComponent implements OnInit {
  @Input({ required: true }) outputName!: string;
  warningMessage$!: Observable<string | undefined>;

  constructor(private store: H3mlStore) {}

  ngOnInit() {
    this.warningMessage$ = this.store('outputInfoByName')(this.outputName)(
      'warningMessage',
    ).$;
  }
}
